"use strict";
/* eslint-disable @typescript-eslint/no-empty-function */

/* eslint-disable functional/no-expression-statement */

/* eslint-disable functional/no-try-statement */

/* eslint-disable functional/no-conditional-statement */

/* eslint-disable functional/functional-parameters */

/* eslint-disable functional/no-return-void */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOafRouter = void 0;

var oaf_side_effects_1 = require("oaf-side-effects");

var _1 = require(".");

var createPageStateMemoryWithFallback = function (settings) {
  var dummyPageStateMemory = {
    pageState: function () {
      return undefined;
    },
    update: function () {}
  };

  if (!settings.restorePageStateOnPop) {
    return dummyPageStateMemory;
  }

  try {
    return (0, _1.createPageStateMemory)();
  } catch (e) {
    console.error(e);
    return dummyPageStateMemory;
  }
};

var documentTitle = function (location, settings) {
  var title = settings.documentTitle(location);

  if ( // Our users might be using raw JavaScript, so we want this warning to apply even in cases
  // that would normally not compile in TypeScript.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  title === null || // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  title === undefined || typeof title !== "string" || title.trim() === "") {
    console.error("Title [".concat(title, "] is invalid. See https://www.w3.org/TR/UNDERSTANDING-WCAG20/navigation-mechanisms-title.html"));
    return undefined;
  } else {
    return title;
  }
};

var createOafRouter = function (settings, hashFromLocation) {
  var resetAutoScrollRestoration = settings.disableAutoScrollRestoration ? (0, _1.disableAutoScrollRestoration)() : function () {};
  var pageStateMemory = createPageStateMemoryWithFallback(settings);
  return {
    handleFirstPageLoad: function (location) {
      return __awaiter(void 0, void 0, void 0, function () {
        var title, hash, focusTarget, didFocus;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              title = documentTitle(location, settings);

              if (settings.setPageTitle && title !== undefined) {
                (0, oaf_side_effects_1.setTitle)(title);
              }

              if (!settings.handleHashFragment) return [3
              /*break*/
              , 2];
              hash = hashFromLocation(location);
              focusTarget = (0, oaf_side_effects_1.elementFromHash)(hash);
              if (!(focusTarget !== undefined)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , (0, oaf_side_effects_1.focusAndScrollIntoViewIfRequired)(focusTarget, focusTarget, settings.smoothScroll)];

            case 1:
              didFocus = _a.sent();

              if (!didFocus) {
                console.warn("Unable to focus element for hash [".concat(hash, "]."));
              }

              _a.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    handleLocationChanged: function (previousLocation, currentLocation, currentLocationKey, action) {
      return __awaiter(void 0, void 0, void 0, function () {
        var title, shouldHandleAction, primaryFocusTarget, shouldRestorePageState, previousPageState, pageStateToSet, hash, focusTarget, didFocus;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              title = documentTitle(currentLocation, settings);

              if (settings.setPageTitle && title !== undefined) {
                (0, oaf_side_effects_1.setTitle)(title);
              }

              shouldHandleAction = settings.shouldHandleAction(previousLocation, currentLocation, action);

              if (!shouldHandleAction) {
                return [2
                /*return*/
                ];
              }

              if (settings.announcePageNavigation) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, oaf_side_effects_1.announce)(settings.navigationMessage(title !== null && title !== void 0 ? title : settings.documentTitleAnnounceFallback, currentLocation, action), settings.announcementsDivId, settings.setMessageTimeout, settings.clearMessageTimeout);
              }

              if (!settings.repairFocus) return [3
              /*break*/
              , 4];
              primaryFocusTarget = typeof settings.primaryFocusTarget === "string" ? settings.primaryFocusTarget : settings.primaryFocusTarget(currentLocation);
              shouldRestorePageState = action === "POP" && settings.restorePageStateOnPop;
              if (!shouldRestorePageState) return [3
              /*break*/
              , 2];
              previousPageState = currentLocationKey !== undefined ? pageStateMemory.pageState(currentLocationKey) : undefined;
              pageStateToSet = __assign(__assign({}, settings.defaultPageState), previousPageState);
              return [4
              /*yield*/
              , (0, _1.setPageState)(pageStateToSet, primaryFocusTarget)];

            case 1:
              _a.sent();

              return [3
              /*break*/
              , 4];

            case 2:
              hash = hashFromLocation(currentLocation);
              focusTarget = settings.handleHashFragment ? (0, oaf_side_effects_1.elementFromHash)(hash) : undefined;
              return [4
              /*yield*/
              , (0, oaf_side_effects_1.resetFocus)(primaryFocusTarget, focusTarget, settings.smoothScroll)];

            case 3:
              didFocus = _a.sent();

              if (!didFocus) {
                console.warn("Unable to focus element for primary focus target [".concat(primaryFocusTarget, "] and hash [").concat(hash, "]."));
              }

              _a.label = 4;

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    handleLocationWillChange: function (currentLocationKey, nextLocationKey, action) {
      if (settings.restorePageStateOnPop) {
        pageStateMemory.update(action, currentLocationKey, nextLocationKey, (0, _1.getPageState)());
      }
    },
    resetAutoScrollRestoration: resetAutoScrollRestoration
  };
};

exports.createOafRouter = createOafRouter;